import React from 'react';
import { message } from 'antd';
import { useNavigate, useParams } from 'react-router-dom';
import UpdateGameForm from '../../components/dashboard/UpdateGameForm';

const UpdateGamePage = () => {
  const { game_id } = useParams(); // Extract game_id from URL
  const navigate = useNavigate();

  // Debug: Verify game_id
  console.log('Game ID from URL:', game_id);

  const handleUpdateSuccess = () => {
    navigate('/dashboard'); // Redirect after successful update
  };

  if (!game_id) {
    message.error('Game ID is missing. Please check the URL.');
    return <p>Error: Game ID is missing.</p>;
  }

  return (
    <div style={{ maxWidth: '600px', margin: '0 auto', padding: '20px' }}>
      <UpdateGameForm gameId={game_id} onUpdateSuccess={handleUpdateSuccess} />
    </div>
  );
};

export default UpdateGamePage;
